import useColorModes from '@github-ui/react-core/use-color-modes'

import copilotAppIconDark from './assets/github-copilot-app-dark.png'
import copilotAppIconLight from './assets/github-copilot-app-light.png'

const copilotAppIconPictureStyle = {
  display: 'block',
  height: 20,
  lineHeight: 0,
  width: 20,
} as const

export function CopilotAppIcon() {
  const {colorMode} = useColorModes()

  return (
    <picture style={copilotAppIconPictureStyle}>
      {colorMode === 'night' && <source srcSet={copilotAppIconDark} />}
      {colorMode === 'auto' && <source srcSet={copilotAppIconDark} media="(prefers-color-scheme: dark)" />}
      <img src={copilotAppIconLight} alt="" height="20" width="20" />
    </picture>
  )
}
